/**
 * Writes `text/plain` and `text/html` to the system clipboard for the paths that
 * have no `ClipboardEvent` to write through — a menu item, or a chord that fires
 * as a `keydown`. The mirror of `readSystemClipboard`.
 *
 * Resolves `false` when the browser refused access, which every caller reports
 * as blocked. Consumed by `useArTableClipboard`'s Copy Rows, `ArRowContextMenu`'s
 * Copy Cell and `FormContextMenu`'s Copy Field. Both MIME types always go in one
 * `ClipboardItem`: the HTML half carries the `data-ar-cell` markers a paste needs
 * to round-trip a value verbatim, and splitting them would drop that half.
 */

type SystemClipboardWrite = { plain: string; html: string };

async function writeSystemClipboard(payload: SystemClipboardWrite): Promise<boolean> {
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Blob([payload.plain], { type: 'text/plain' }),
        'text/html': new Blob([payload.html], { type: 'text/html' }),
      }),
    ]);
    return true;
  } catch {
    return false;
  }
}

export { writeSystemClipboard };
export type { SystemClipboardWrite };
